import { render, staticRenderFns } from "./Bedroom.vue?vue&type=template&id=5d3618be&"
import script from "./Bedroom.vue?vue&type=script&lang=ts&"
export * from "./Bedroom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports